import React, { SVGAttributes } from 'react';

const LinkCopy = (props: SVGAttributes<SVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
        <defs />
        <g fill="none" fillRule="evenodd">
            <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
            <path
                fill="currentColor"
                d="M10.198 6.389V4.283c0-.245.303-.374.493-.21l5.088 4.394c.13.112.13.307 0 .419L10.693 13.3c-.19.165-.494.036-.494-.21v-2.153s-5.206-.473-7.769 4.913c-.126.265-.553.15-.552-.14.003-2.352 2.181-9.322 8.32-9.322"
            />
        </g>
    </svg>
);
export default LinkCopy;
